import React, { Component } from 'react'
import {
    withRouter
} from 'react-router-dom'
import { Container, Row, Col, Button, Modal, Form } from 'react-bootstrap'
import 'core-js';
import _ from 'lodash'
import moment from 'moment'

import Page from './Page'
import '../styles/global.css'
import '../helpers/NumberHelpers'
import numberHelpers from '../helpers/NumberHelpers'



class CheckTickets extends Page {

    state = {
        phone: "",
        tickets: null,
        fetchingTickets: false
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.setState({ tickets: null, fetchingTickets: false })
        }
    }

    _checkTickets() {
        let self = this

        self.setState({
            phone: self.state.phone.replace(/ /g, "")
        }, () => {

            if (self.state.phone.length < 10) {
                alert("Please enter a valid mobile phone number.")
            } else {
                self.setState({ fetchingTickets: true }, () => {
                    self.props.getEventPurchases(self.props.eventId, self.state.phone, {
                        source: self.props.eventSource,
                        clientUrl: self.props.clientUrl || (self.props.client && self.props.client.stub)
                    }, (tickets) => {
                        self.setState({ tickets: tickets }, () => {
                            self.setState({ fetchingTickets: false })
                        })
                    })
                })
            }
        })

    }

    render() {
        let self = this

        let tickets = null
        if (this.state.fetchingTickets) {
            tickets = <div>Checking tickets...</div>
        } else if (this.state.tickets) {
            if (this.state.tickets.length == 0) {
                tickets = <div>No tickets were purchased in #{this.props.eventId} with the phone number {this.state.phone}</div>
            } else {
                let ticketRows = []
                for (var i = 0; i < this.state.tickets.length; i++) {
                    for (var j = 0; j < this.state.tickets[i].ticketCount; j++) {
                        const eventCode = this.state.tickets[i].eventId || this.state.tickets[i].PK
                        const ticketNumber = Number(this.state.tickets[i].ticketIndex || 0) + j
                        ticketRows.push(
                            <li>{eventCode}_{numberHelpers.pad(ticketNumber, 3)}{self.props.winningTicketId == ticketNumber ? <b> - WINNER</b> : ""}</li>
                        )
                    }

                }
                tickets = <ul>{ticketRows}</ul>
            }
        }

        if (this.props.v2) {
            const eventTitle = (this.props.event && (this.props.event.name || this.props.event.title)) || "this event"
            const hasChecked = Boolean(this.state.tickets)

            if (!this.props.show) return null

            return (
                <div className="v2-modal-shell v2-check-ticket-shell">
                    <div className="v2-modal-card v2-check-ticket-card">
                        <button className="v2-modal-close" onClick={this.props.onHide}>×</button>
                        <p className="v2-modal-eyebrow">Check tickets</p>
                        <h2>Find your tickets</h2>
                        <p className="v2-check-ticket-intro">
                            Enter the mobile number used at checkout and we’ll show the tickets purchased for {eventTitle}.
                        </p>
                        <Form className="v2-check-ticket-form" onSubmit={(event) => { event.preventDefault(); this._checkTickets() }}>
                            <Form.Group>
                                <Form.Label>Mobile number</Form.Label>
                                <Form.Control
                                    type="tel"
                                    placeholder="0400 000 000"
                                    onChange={(e) => {
                                        self.setState({ phone: e.target.value, tickets: null })
                                    }}
                                    value={self.state.phone} />
                            </Form.Group>
                            <Button disabled={this.state.fetchingTickets} className="v2-check-ticket-submit" onClick={() => this._checkTickets()}>
                                {this.state.fetchingTickets ? "Checking" : "Check tickets"}
                            </Button>
                        </Form>
                        <div className="v2-check-ticket-results">
                            {this.state.fetchingTickets ? (
                                <div className="v2-check-ticket-status">Checking tickets...</div>
                            ) : hasChecked && this.state.tickets.length === 0 ? (
                                <div className="v2-check-ticket-empty">No tickets were found for that mobile number.</div>
                            ) : hasChecked ? (
                                tickets
                            ) : null}
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <Modal {...this.props} onEnter={
                () => {
                    this.setState({ tickets: null, fetchingTickets: false })
                }
            }>
                <Modal.Header closeButton>
                    <Modal.Title>Check your ticket for event #{this.props.eventId}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    Enter the mobile phone number that your tickets were sent to:<br />
                    <Form>
                        <Form.Group>
                            <Form.Label>Mobile Number</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Mobile number"
                                onChange={(e) => {
                                    self.setState({ phone: e.target.value, tickets: null })
                                }}
                                value={self.state.phone} />
                        </Form.Group>
                        <Button className="btn btn-tertiary" onClick={() => this._checkTickets()}>Check Tickets</Button>
                    </Form>

                    {tickets}

                </Modal.Body>
            </Modal>
        )
    }
}

export default withRouter(CheckTickets)
